import React from "react";
import { connect } from "react-redux";
import { format } from 'date-fns'
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
  DateTimePicker,
} from "@material-ui/pickers";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button"
import DateFnsUtils from "@date-io/date-fns";
import { ReactMultiEmail } from "react-multi-email";
import MMPLCrewVisitorCard from "./MMPLCrewVisitorCard";
import {
  getCrewSearchList,
  ExportExcelCrew,
  getShipnameList,
  getTimezonenameList,
  getCrewSearchListDidmount
} from "../Actions/HelpersAPI";
import Role from "../helpers/role";
import DatePicker from "react-datepicker";
import { AiOutlineClose } from "react-icons/ai";
import Moment from "moment";
import Autocomplete from "react-autocomplete";
import axios from "axios";
import * as $ from "jquery";
import API from "../helpers/api";
import swal from "sweetalert";
import Modal from "react-bootstrap/Modal";

let userRole = localStorage.getItem("UserRoles");
let user = JSON.parse(localStorage.getItem("currentUser"));

const fontStyles = { fontSize: "20px" };

class CrewVisitorSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      receivedDateIsOpen: false,
      testcompletedDateIsOpen: false,
      calibrationExpiryDateIsOpen: false,
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: false,
      SelectedFromDate: "",
      SelectedToDate: "",
      SelectedCalibrationDate: "",
      SelectedTestCompletedDate: "",
      SelectedReceivedDate: "",
      searchData: {
        // shipId: localStorage.getItem("shipId"),
        ShipId: 0,
        crewId: "",
        PageNumber: 1,
        isPass: false,
        showAllResult: false,
        PageSize: 25,
        crewName: "",
        shipName: "",
        fromDate: "",
        toDate: "",
        ExcludeRefuse: true,
        isAll: true,
        deviceId: 0,
      },
      generateData: {
        remark: "",
        receivedDate: new Date().toISOString(),
        testcompletedDate: new Date().toISOString(),
        location: "",
        initiatedBy: "",
        testadmin: "",
        witness1: "",
        witness2: "",
        excludeFail: false,
        sendtomail: false,
        tomail: "",
        timeZoneId: "",
      },
      InvalidToMail: [],
      tomail: [],
      verifytomail: [],
      isMobile: false,
      modalIsOpen: false,
      True: false,
      False: false,
      All: false,
      Excluderefuse: true,
    };
    this.SearchCrew = this.SearchCrew.bind(this);
    this.ClearInput = this.ClearInput.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFromDateChange = this.handleFromDateChange.bind(this);
    this.handleToDateChange = this.handleToDateChange.bind(this);
    this.GenerateReport = this.GenerateReport.bind(this);
  }

  componentDidMount() {
    // this.props.dispatch(getMDSearchlist(this.state.searchDate));
    const { dispatch, match } = this.props;
    dispatch({ type: "SubBannerTitle", data: "Search" });
    if (match?.params?.id) {
      this.state.searchData.crewId = match.params.id;
    }
    dispatch(getCrewSearchListDidmount(this.state.searchData, 1));
    // dispatch(getShipnameList());
    // dispatch(getTimezonenameList());
    window.addEventListener("resize", this.resize.bind(this));
    // this.interval = setInterval(() => {
    //   this.resize();
    // }, 10);
    // dispatch({type: "SHOW_LOADER",})
    window.setTimeout(dispatch({ type: "HIDE_LOADER", data: false }));
  }

  resize = () => {
    if (window.innerWidth < 590) {
      this.setState({
        isMobile: true,
      });
    } else {
      this.setState({
        isMobile: false,
      });
    }
  };

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   const { dispatch, match } = nextProps;
  //   if (match?.params?.id) {
  //     prevState.searchData.crewId = match.params.id;
  //   }
  // }

  SearchCrew(pgno) {
    const { dispatch } = this.props;

    if (
      this.state.searchData.toDate !== "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the from date", "warning");
    }
    if (this.state.searchData.toDate === "") {
      if (this.state.searchData.fromDate > Moment().format("YYYY-MM-DD")) {
        swal("Error!", "Please select the to date", "warning");
      }
    }
    if (
      this.state.searchData.fromDate != "" &&
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate < Moment().format("YYYY-MM-DD")
    ) {
      this.state.searchData.toDate = Moment().format("YYYY-MM-DD");
      this.setState({});
      this.state.searchData.PageNumber = pgno;
      dispatch(getCrewSearchList(this.state.searchData, pgno));
    }
    if (
      (this.state.searchData.fromDate === "" &&
        this.state.searchData.toDate === "") ||
      (this.state.searchData.fromDate !== "" &&
        this.state.searchData.toDate !== "")
    ) {
      this.state.searchData.PageNumber = pgno;
      dispatch(getCrewSearchList(this.state.searchData, pgno));
    }
  }
  ExportExcel(pgno) {
    const { dispatch } = this.props;
    dispatch(ExportExcelCrew(this.state.searchData, pgno));
  }
  GenerateReport() {
    if (
      this.state.searchData.shipName === "" &&
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the shipname and date", "warning");
      return;
    }
    if (
      this.state.searchData.shipName === "") {
      swal("Error!", "Please select the shipname", "warning");
      return;
    }
    if (
      this.state.searchData.toDate === "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the date", "warning");
      return;
    }
    if (
      this.state.searchData.toDate !== "" &&
      this.state.searchData.fromDate === ""
    ) {
      swal("Error!", "Please select the from date", "warning");
      return;
    }
    if (
      this.state.searchData.fromDate != "" &&
      this.state.searchData.toDate === ""
    ) {
      swal("Error!", "Please select the to date", "warning");
      return;
    }

    this.setState({ modalIsOpen: !this.state.modalIsOpen });
  }

  handleInputChange(e) {
    let nodeName = e.target.name;
    this.state.searchData[nodeName] = e.target.value;
    this.setState({});
  }
  handleInputChangeReport(e) {
    let nodeName = e.target.name;
    this.state.generateData[nodeName] = e.target.value;
    this.setState({});
  }
  handleBlur() {
    this.setState({
      toDatePickerIsOpen: false,
      fromDatePickerIsOpen: false,
      testcompletedDateIsOpen: false,
      receivedDateIsOpen: false,
      calibrationExpiryDateIsOpen: false,
    });
  }
  handleCheckBoxChange(e) {
    if (e.target.checked) {
      this.state.generateData.excludeFail = true;
      this.setState({})
    } else {
      this.state.generateData.excludeFail = false;
      this.setState({})
    }
  }
  handleEmailCheckBoxChange(e) {

    if (e.target.checked) {
      this.state.generateData.sendtomail = true;
      this.setState({})
    } else {
      this.state.generateData.sendtomail = false;
      this.setState({})
    }
  }

  validateToEmail = async (email) => {
    email.map((item) => {
      if (item !== "") {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (item.match(mailformat)) {
        } else {
          var c = this.state.InvalidToMail.push(item);
          this.setState(
            {
              InvalidToMail: this.state.InvalidToMail,
            },
            () => {
              console.log(this.state.InvalidToMail);
              console.log(this.state.tomail);
            }
          );
        }
      }
    });
  };

  handleFromDateChange(date) {
    this.state.searchData.fromDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedFromDate: date,
      fromDatePickerIsOpen: false,
    });
  }
  handleToDateChange(date) {
    this.state.searchData.toDate = Moment(new Date(Date.parse(date))).format(
      "YYYY-MM-DD"
    );
    this.setState({
      SelectedToDate: date,
      toDatePickerIsOpen: false,
    });
  }
  openFromDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: !this.state.fromDatePickerIsOpen,
      toDatePickerIsOpen: false,
    });
  };
  openToDatePicker = () => {
    this.setState({
      fromDatePickerIsOpen: false,
      toDatePickerIsOpen: !this.state.toDatePickerIsOpen,
    });
  };

  ClearInput() {
    this.state.SelectedFromDate = "";
    this.state.SelectedToDate = "";
    this.state.searchData.crewId = "";
    this.state.searchData.crewName = "";
    this.state.searchData.shipName = "";
    this.state.searchData.fromDate = "";
    this.state.searchData.toDate = "";
    this.state.searchData.ShipId = 0;
    this.state.searchData.isPass = false;
    this.state.searchData.showAllResult = false;
    this.state.searchData.ExcludeRefuse = true;
    this.setState({
      True: false,
      False: false,
      All: false,
      Excluderefuse: true,
    });
    this.props.dispatch(getCrewSearchList(this.state.searchData, 1));
  }
  handleRadioInputChange = (e) => {
    let nodeName = e.target.name;
    if (nodeName === "True") {
      this.state.searchData.isPass = true;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({
        True: true,
        False: false,
        All: false,
        Excluderefuse: false,
      });
    } else if (nodeName === "False") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({
        True: false,
        False: true,
        All: false,
        Excluderefuse: false,
      });
    } else if (nodeName === "All") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = true;
      this.state.searchData.ExcludeRefuse = false;
      this.setState({
        True: false,
        False: false,
        All: true,
        Excluderefuse: false,
      });
    } else if (nodeName === "Excluderefuse") {
      this.state.searchData.isPass = false;
      this.state.searchData.showAllResult = false;
      this.state.searchData.ExcludeRefuse = true;
      this.setState({
        True: false,
        False: false,
        All: false,
        Excluderefuse: true,
      });
    }
  };
  HandlePicker(str, e) {
    if (str == "testdatetime") {
      let datetime = new Date(Date.parse(e)).toISOString();
      let value = Moment.utc(datetime).local().format()
      this.state.generateData.testcompletedDate = value;
    }
    if (str == "receiveddatetime") {
      let datetime = new Date(Date.parse(e)).toISOString();
      let value = Moment.utc(datetime).local().format()
      this.state.generateData.receivedDate = value;
    }
  }

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (value, field, id, fieldId) => {
    const { dispatch } = this.props;
    this.state.searchData[field] = value;
    this.state.searchData[fieldId] = id;
    this.setState({});
  };
  submitGenerateData = () => {
    if (
      this.state.generateData.remark === "" ||
      this.state.generateData.location === "" ||
      this.state.generateData.receivedDate === "" ||
      this.state.generateData.testcompletedDate === "" ||
      this.state.generateData.initiatedBy === "" ||
      this.state.generateData.testadmin === "" ||
      this.state.generateData.witness1 === "" ||
      this.state.generateData.witness2 === "" ||
      this.state.generateData.timeZoneId === ""
    ) {
      this.state.generateData.remark === ""
        ? $("#chargeDescriptionErrMsg").text("This field is required")
        : $("#chargeDescriptionErrMsg").text("");
      this.state.generateData.location === ""
        ? $("#locationErrMsg").text("This field is required")
        : $("#locationErrMsg").text("");
      this.state.generateData.receivedDate === ""
        ? $("#receivedDateErrMsg").text("This field is required")
        : $("#receivedDateErrMsg").text("");
      this.state.generateData.testcompletedDate === ""
        ? $("#testcompletedDateErrMsg").text("This field is required")
        : $("#testcompletedDateErrMsg").text("");
      this.state.generateData.timeZoneId === ""
        ? $("#timezoneErrMsg").text("This field is required")
        : $("#timezoneErrMsg").text("");
      this.state.generateData.initiatedBy === ""
        ? $("#initiatedByErrMsg").text("This field is required")
        : $("#initiatedByErrMsg").text("");
      this.state.generateData.testadmin === ""
        ? $("#testadminErrMsg").text("This field is required")
        : $("#testadminErrMsg").text("");
      this.state.generateData.witness1 === ""
        ? $("#witness1ErrMsg").text("This field is required")
        : $("#witness1ErrMsg").text("");
      this.state.generateData.witness2 === ""
        ? $("#witness2ErrMsg").text("This field is required")
        : $("#witness2ErrMsg").text("");
      return;
    } else {
      $("#chargeDescriptionErrMsg").text("");
      $("#locationErrMsg").text("");
      $("#receivedDateErrMsg").text("");
      $("#testcompletedDateErrMsg").text("");
      $("#initiatedByErrMsg").text("");
      $("#testadminErrMsg").text("");
      $("#witness1ErrMsg").text("");
      $("#witness2ErrMsg").text("");
      $("#timezoneErrMsg").text("");
    }
    this.state.InvalidToMail = [];
    let a = [$("div.tomail>input").val()];
    var b = [];
    if (a[0]) {
      b = a.concat(this.state.tomail);
    }
    if (b.length !== 0) {
      this.state.verifytomail = b;
    } else {
      this.state.verifytomail = this.state.tomail;
    }

    if (this.state.generateData.sendtomail) {
      if (this.state.verifytomail.length === 0) {
        $("#tomailErrMsg").text("This field is required")
        return;
      } else {
        $("#tomaiErrMsg").text("");
      }
    }
    if (this.state.verifytomail.length !== 0) {
      this.validateToEmail(b);
      console.log(this.state.InvalidToMail.length);
      if (this.state.InvalidToMail.length > 0) {
        swal("Error!", "Invalid tomail", "warning");
        return;
      }
    }
    let result = {
      shipId: parseInt(this.state.searchData.ShipId),
      remarks: this.state.generateData.remark,
      startDate: this.state.searchData.fromDate,
      endDate: this.state.searchData.toDate,
      actionBy: user.email,
      shipName: this.state.searchData.shipName,
      data: {
        location: this.state.generateData.location,
        instructionDate: Moment(new Date(Date.parse(this.state.generateData.receivedDate))).format("YYYY-MM-DD HH:mm"),
        testCompletedDate: Moment(new Date(Date.parse(this.state.generateData.testcompletedDate))).format("YYYY-MM-DD HH:mm"),
        initiatedBy: this.state.generateData.initiatedBy,
        testAdmin: this.state.generateData.testadmin,
        witnessOne: this.state.generateData.witness1,
        witnessTwo: this.state.generateData.witness2,
        excludeFail: this.state.generateData.excludeFail,
        email: this.state.tomail ? this.state.tomail.length === 0 ? null : this.state.tomail.toString() : null,
        timeZoneId: parseInt(this.state.generateData.timeZoneId ? this.state.generateData.timeZoneId : 0)
      },
    };
    let url = `${API.AddReport}`;
    axios
      .post(url, result)
      .then((response) => {
        if (response.data) {
          this.clearModelData();
          this.state.tomail = [];
          this.state.InvalidToMail = [];
          this.state.verifytomail = [];
          this.setState({ modalIsOpen: false });
          swal("Success!", "Report Details added successfully", "success");
        }
      })
      .catch((error) => {
        if (error.response.status === 400) {
          swal("Error!", error.response.data, "warning");
        } else {
          swal("Error!", "Something went wrong. Please try again.", "warning");
        }
        console.log("Error in Add settings Visitor" + error);
      });
  };
  clearModelData = () => {
    this.state.searchData.shipName = "";
    this.state.searchData.fromDate = "";
    this.state.searchData.toDate = "";
    this.state.SelectedFromDate = "";
    this.state.SelectedToDate = "";
    this.state.searchData.ShipId = 0;
    this.setState(
      {
        generateData: {
          remark: "",
          location: "",
          initiatedBy: "",
          testadmin: "",
          witness1: "",
          witness2: "",
          timeZoneId: "",
          excludeFail: false,
          sendtomail: false,
          receivedDate: new Date().toISOString(),
          testcompletedDate: new Date().toISOString(),
        },
        modalIsOpen: !this.state.modalIsOpen,
      },
      () => {
        console.log(this.state.generateData);
      }
    );
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }
  render() {
    const { Loading, TimeZoneNameList } = this.props;
    const { tomail } = this.state;
    return (
      <div className="pb-3">
        <Modal
          size="lg"
          show={this.state.modalIsOpen}
          onHide={() => this.setState({ modalIsOpen: false })}
          aria-labelledby="example-modal-sizes-title-sm"
          backdrop="static"
          centered="true"
          animation="true"
        >
          <div className="px-4 py-4">
            <label className="fo-title">Report Details</label>
            <AiOutlineClose
              className="close"
              style={fontStyles}
              onClick={() => this.clearModelData()}
            />
            <div
              style={{
                borderBottom: "2px solid #1E3A8A",
                paddingTop: 5,
              }}
            ></div>
            <div
              className="px-4 pb-2"
              style={{
                backgroundColor: "#F9F9F9",
                borderRadius: 0,
                border: "none",
              }}
            >
              <div className="row pt-3">
                <div className="col-sm-4">
                  <label className="form-label fontstyle required">Location</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="location"
                    value={this.state.generateData.location}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  ></input>
                  <span id="locationErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-sm-4">
                  <label className="form-label fontstyle required">
                    Instruction Received Date
                  </label>
                  <br></br>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                      autoOk={true}
                      ampm={false}
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control"
                      format="yyyy/MM/dd HH:mm"
                      KeyboardButtonProps={{
                        "aria-label": "change date",
                      }}
                      keyboardIcon={
                        <Icon
                          className="fa fa-calendar"
                          style={{ fontSize: "18px" }}
                        />
                      }
                      value={this.state.generateData.receivedDate}
                      size="small"
                      onChange={(e) => this.HandlePicker("receiveddatetime", e)}
                    />
                    <span className="spanErrMsg ">
                      Note:Please select UTC time
                    </span>
                    <span
                      id="receivedDateErrMsg"
                      className="spanErrMsg"
                    ></span>
                  </MuiPickersUtilsProvider>
                </div>

                <div className="col-sm-4">
                  <label className="form-label fontstyle required">
                    Test Completed Date
                  </label>
                  <br></br>

                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDateTimePicker
                      ampm={false}
                      autoOk={true}
                      variant="inline"
                      inputVariant="outlined"
                      className="form-control"
                      format="yyyy/MM/dd HH:mm"
                      KeyboardButtonProps={{
                        "aria-label": "change complete date",
                      }}
                      keyboardIcon={
                        <Icon
                          className="fa fa-calendar"
                          style={{ fontSize: "18px" }}
                        />
                      }
                      value={this.state.generateData.testcompletedDate}
                      size="small"
                      onChange={(e) => this.HandlePicker("testdatetime", e)}
                    />
                    <span className="spanErrMsg ">
                      Note:Please select UTC time
                    </span>
                    <span
                      id="testcompletedDateErrMsg"
                      className="spanErrMsg "
                    ></span>
                  </MuiPickersUtilsProvider>
                </div>
                <div className="col-sm-4 mt-2">
                  <label className="form-label fontstyle required">Time Zone</label>
                  <br></br>
                  <select
                    className="form-control"
                    name="timeZoneId"
                    value={this.state.generateData.timeZoneId}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  >
                    <option value="">Select Time Zone</option>
                    {TimeZoneNameList &&
                      TimeZoneNameList.map((i) => (
                        <option value={i.id}>{i.timeZoneName}</option>
                      ))}
                  </select>
                  <span
                    id="timezoneErrMsg"
                    className="spanErrMsg"
                  ></span>
                </div>
                <div className="col-sm-4 mt-2">
                  <label className="form-label fontstyle required">
                    Test Initiated By
                  </label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="initiatedBy"
                    value={this.state.generateData.initiatedBy}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  ></input>
                  <span
                    id="initiatedByErrMsg"
                    className="spanErrMsg"
                  ></span>
                </div>
                <div className="col-sm-4 mt-2">
                  <label className="form-label fontstyle required">
                    Test Administrator
                  </label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="testadmin"
                    value={this.state.generateData.testadmin}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  ></input>
                  <span id="testadminErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-sm-4 mt-2">
                  <label className="form-label fontstyle required">Witness #1</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="witness1"
                    value={this.state.generateData.witness1}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  ></input>
                  <span id="witness1ErrMsg" className="spanErrMsg"></span>
                </div>
                <div className="col-sm-4 mt-2">
                  <label className="form-label fontstyle required">Witness #2</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="witness2"
                    value={this.state.generateData.witness2}
                    onChange={(e) => this.handleInputChangeReport(e)}
                  ></input>
                  <span id="witness2ErrMsg" className="spanErrMsg"></span>
                </div>
                {/* <div className="col-lg-2 mt-2">
                  <label className="form-label fontstyle" >Exclude Fail</label><br></br>
                  <input type="checkbox" name="excludefail" style={{ height: "15px", width: "15px" }} checked={this.state.generateData.excludeFail} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                </div>
                <div className="col-lg-2 mt-2">
                  <label className="form-label fontstyle">Send Email Notification</label><br></br>
                  <input type="checkbox" name="sendtomail" style={{ height: "15px", width: "15px" }} checked={this.state.generateData.sendtomail} onChange={(e) => this.handleEmailCheckBoxChange(e)}></input>
                </div> */}

                {this.state.generateData.sendtomail ?
                  <div className="col-lg-4">
                    <label className="form-label fontstyle required">To Email</label>
                    <br></br>
                    <ReactMultiEmail
                      className="tomail"
                      emails={tomail}
                      onChange={(_emails) => {
                        this.setState({ tomail: _emails }, () => {
                          console.log("valu", $("div.tomail>input").val());
                        });
                      }}
                      getLabel={(email, index, removeEmail) => {
                        return (
                          <label
                            className="m-1"
                            key={index}
                            style={{
                              backgroundColor: "lightgray",
                              fontSize: "14px",
                              wordBreak: "break-word",
                            }}
                          >
                            {email}
                            <span
                              style={{
                                fontSize: "20px",
                                verticalAlign: "middle",
                                marginLeft: ".25rem",
                              }}
                              data-tag-handle
                              name="delete"
                              onClick={() => removeEmail(index)}
                            >
                              &times;
                            </span>
                          </label>
                        );
                      }}
                    />
                    <span id="tomailErrMsg" className="spanErrMsg"></span>
                  </div> : null}
                <div className="col-12">
                  <input type="checkbox" name="excludefail" style={{ height: "15px", width: "15px" }} checked={this.state.generateData.excludeFail} onChange={(e) => this.handleCheckBoxChange(e)}></input>
                  <label className="form-label fontstyle ml-2" >Exclude Fail</label>&nbsp;&nbsp;
                  <input type="checkbox" name="sendtomail" style={{ height: "15px", width: "15px" }} checked={this.state.generateData.sendtomail} onChange={(e) => this.handleEmailCheckBoxChange(e)}></input>
                  <label className="form-label fontstyle ml-2">Send Email Notification</label>
                </div>
              </div>
            </div>
            <div className="px-2 py-2">
              <label className="fo-title">Remark</label>

              <div
                style={{
                  borderBottom: "2px solid #1E3A8A",
                  paddingTop: 5,
                }}
              ></div>
              <div
                className="px-4 pb-3 pt-1"
                style={{
                  backgroundColor: "#F9F9F9",
                  borderRadius: 0,
                  border: "none",
                }}
              >
                <div className="row">
                  <div className="col-sm-12">
                    <label className="form-label fontstyle required">Remarks</label>
                    <br></br>
                    <textarea
                      className="form-control"
                      style={{
                        resize: "none",
                        height: 50,
                        marginTop: 8,
                        borderRadius: 0,
                        borderColor: "#DEDDDD",
                      }}
                      rows={5}
                      autoComplete="off"
                      maxLength={250}
                      name="remark"
                      value={this.state.generateData.remark}
                      onChange={(e) => this.handleInputChangeReport(e)}
                      onBlur={(e) => $("#errorTextOrderNewRemarks").text("")}
                    ></textarea>
                    <span
                      id="chargeDescriptionErrMsg"
                      className="spanErrMsg"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="form-group search-btn-col mt-4"
              style={{ textAlign: "end" }}
            >
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                type="submit"
                onClick={() => this.submitGenerateData()}
              >
                {" "}
                Submit{" "}
              </button>
              <button
                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                type="button"
                onClick={() => this.clearModelData()}
              >
                {" "}
                Cancel{" "}
              </button>
            </div>
          </div>
        </Modal>

        {this.renderCardData()}
      </div>
    );
  }

  renderCardData() {
    const { ShipNameList, CrewList, showShipName, Loading } = this.props;
    return (
      <div className="full-height">
        <div className="grey-bg  course-list-page">
          <div className="pt-3">
            <div className="row px-3 pb-3">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.BacktoPrevious()}
              >
                <div style={{ position: 'relative' }}>
                  <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                </div>
              </button>
            </div>
            <div
              className="card MM-card-header mb-0"
              style={{ backgroundColor: "white" }}
            >
              <div
                className="card-body flex"
                style={{
                  padding: "0rem",
                  backgroundColor: "#1a3464",
                  color: "white",
                }}
              >
                <h5
                  className="card-title ml-1 mt-2 pl-3"
                  style={{ color: "092a51" }}
                >
                  Reports
                </h5>
              </div>
            </div>
            <div className="panel-box  search-filter-box mb-3">
              <div className="row" style={{ paddingBottom: "12px" }}>
                <div className="col-lg-4 ">
                  <label className="form-label">Crew ID</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="crewId"
                    placeholder="Crew ID"
                    onChange={(e) => this.handleInputChange(e)}
                    value={this.state.searchData.crewId}
                  ></input>
                </div>
                <div className="col-lg-4 ">
                  <label className="form-label">Name</label>
                  <br></br>
                  <input
                    className="form-control"
                    type="text"
                    name="crewName"
                    placeholder="Name"
                    onChange={(e) => this.handleInputChange(e)}
                    value={this.state.searchData.crewName}
                  ></input>
                </div>
                {userRole == Role.staff
                  ? (<></>) : (
                    <div className="col-lg-4">
                      <div
                        className="autocomplete-wrappers"
                        style={{
                          zIndex: showShipName ? 0 : null,
                        }}
                      >
                        <label className="form-label">Ship Name</label>
                        <br></br>
                        <Autocomplete
                          contentEditable={true}
                          value={this.state.searchData.shipName}
                          inputProps={{
                            placeholder: "Ship Name",
                          }}
                          items={ShipNameList ?? []}
                          getItemValue={(item) => item.shipName}
                          shouldItemRender={this.renderShipNameTitle.bind(this)}
                          renderMenu={(item) => (
                            <div className="dropdown">{item}</div>
                          )}
                          renderItem={(item, isHighlighted) => (
                            <div
                              className={`items ${isHighlighted ? "selected-items" : ""
                                }`}
                            >
                              {item.shipName}
                            </div>
                          )}
                          onChange={(e) => this.handleAnnualSearchChange(e)}
                          onSelect={(value, item) =>
                            this.handleAnnualSelectChange(
                              value,
                              "shipName",
                              item.shipID,
                              "ShipId"
                            )
                          }
                        />
                      </div>
                    </div>
                  )}
                <div className={`col-lg-4 col-sm-12 ${userRole == Role.staff ? "mt-0" : "mt-2"} `}>
                  <label className="form-label">Date</label>
                  <br></br>
                  <div className="row">
                    <div className="col-sm-6">
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                        style={{
                          zIndex:
                            this.state.fromDatePickerIsOpen && !Loading
                              ? 999999
                              : null,
                        }}
                      >
                        <input
                          type="text"
                          value={this.state.searchData.fromDate}
                          className="form-control date-picker"
                          placeholder="From"
                          name="fromDate"
                        ></input>
                        <DatePicker
                          onChange={this.handleFromDateChange}
                          open={this.state.fromDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          startDate={this.state.SelectedFromDate}
                          maxDate={this.state.SelectedToDate}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement={`${this.state.isMobile ? "top-end" : "bottom"}`}
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.openFromDatePicker}
                        >
                          <button
                            className="btn btn-default"
                            style={{ height: "100%" }}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6 margin">
                      <div
                        className="input-group add-on date datepicker"
                        data-date-format="yyyy-mm-dd"
                        style={{
                          zIndex:
                            this.state.toDatePickerIsOpen && !Loading
                              ? 999999
                              : null,
                        }}
                      >
                        <input
                          type="text"
                          value={this.state.searchData.toDate}
                          className="form-control date-picker"
                          placeholder="To"
                          name="toDate"
                        ></input>
                        <DatePicker
                          onChange={this.handleToDateChange}
                          open={this.state.toDatePickerIsOpen}
                          onClickOutside={this.handleBlur}
                          endDate={this.state.SelectedToDate}
                          minDate={this.state.SelectedFromDate}
                          showMonthDropdown
                          showYearDropdown
                          dropdownMode="select"
                          popperPlacement="top-end"
                          className="form-control date-picker w-5 hide-date"
                        />
                        <div
                          className="input-group-btn calendar-icon"
                          onClick={this.openToDatePicker}
                        >
                          <button
                            className="btn btn-default"
                            style={{ height: "100%" }}
                          >
                            <i className="fa fa-calendar mt-1"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-8 mt-2">
                  <label className="form-label">Result</label>
                  <br></br>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-md-12 col-12">
                      <input
                        type="radio"
                        name="True"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.True}
                      ></input>
                      <label className="radioButton">Pass</label>&nbsp;&nbsp;&nbsp;
                      <input
                        type="radio"
                        name="False"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.False}
                      ></input>

                      <label className="radioButton">Fail</label>&nbsp;&nbsp;&nbsp;
                      <input
                        type="radio"
                        name="Excluderefuse"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.Excluderefuse}
                      ></input>
                      <label className="radioButton">Exclude Refuse</label>&nbsp;&nbsp;&nbsp;
                      <input
                        type="radio"
                        name="All"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.All}
                      ></input>
                      <label className="radioButton">All</label>
                    </div>

                    {/* <div className="col-lg-2 col-sm-3 col-md-2 col-3">
                      <input
                        type="radio"
                        name="False"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.False}
                      ></input>

                      <label className="radioButton">Fail</label>
                    </div>
                    <div
                      className={`${
                        this.state.isMobile ? "px-0" : ""
                      } col-lg-4 col-sm-4 col-md-3 col-4`}
                    >
                      <input
                        type="radio"
                        name="Excluderefuse"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.Excluderefuse}
                      ></input>
                      <label className="radioButton">Exclude Refuse</label>
                    </div>
                    <div className="col-lg-2 col-sm-2 col-md-2 col-2">
                      <input
                        type="radio"
                        name="All"
                        onChange={(e) => this.handleRadioInputChange(e)}
                        checked={this.state.All}
                      ></input>
                      <label className="radioButton">All</label>
                    </div> */}
                  </div>
                </div>

                <div className="col-md-12 col-sm-12 d-flex justify-content-end mt-3 flex-sm-row flex-column">
                  {/* <div
                    className="mt-3 search-btn-col"
                    style={{ textAlign: "end" }}
                  > */}
                  <div>
                    {userRole == Role.client || userRole == Role.clientuser || userRole == Role.consultant || userRole == Role.mmpl ? (<></>) : (
                      <button
                        className="btn btn-primary text-uppercase txtside-btn txtht-btn "
                        type="button"
                        onClick={() => this.GenerateReport()}
                      >
                        {" "}
                        Generate Report{" "}
                      </button>
                    )}
                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-2"
                      type="button"
                      onClick={() => this.ExportExcel(1)}
                    >
                      {" "}
                      Export Excel{" "}
                    </button>
                  </div>
                  <div className="mt-xs-3">
                    <button
                      className="btn btn-primary text-uppercase txtside-btn txtht-btn blue ml-2"
                      type="submit"
                      onClick={() => this.SearchCrew(1)}
                    >
                      {" "}
                      Search{" "}
                    </button>

                    <button
                      className="btn btn-light text-uppercase txtside-btn txtht-btn ml-2"
                      type="button"
                      onClick={() => this.ClearInput()}
                    >
                      {" "}
                      Clear{" "}
                    </button>
                  </div>
                  {/* </div> */}
                </div>
              </div>
            </div>
            {CrewList ? (
              <MMPLCrewVisitorCard
                arraylist={CrewList.data}
                pageSize={CrewList.pagination.pageSize}
                totalRecords={
                  CrewList.pagination.totalcount
                    ? CrewList.pagination.totalcount
                    : 0
                }
                setUpdatedState={(value) => this.SearchCrew(value)}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    CrewList: state.SidePanReducer.crewSearchDetails,
    showShipName: state.SidePanReducer.shipName || false,
    ShipNameList: state.UserManageReducer.ShipNameList || [],
    Loading: state.PageLoaderReducer.loading,
    TimeZoneNameList: state.UserManageReducer.TimeZoneNameList
  };
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(CrewVisitorSearch);
